<template>
    <uw-page title="任务列表">

        
        <template slot="header-suffix">
            <el-dropdown trigger="click">
                <el-button type="primary" >批量管理<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native.stop="$refs.taskCreateMultiple.Open(projects_id)">批量创建任务</el-dropdown-item>
                    <el-dropdown-item @click.native.stop="TaskEditAssign()">批量修改任务成员</el-dropdown-item>
                    <el-dropdown-item @click.native.stop="TaskDeleteMultiple()" divided>批量删除</el-dropdown-item>
                    <el-dropdown-item @click.native.stop="TaskFlowStartMultiple()" divided>批量开始</el-dropdown-item>
                    <el-dropdown-item @click.native.stop="TaskFlowSuspendMultiple()">批量暂停</el-dropdown-item>
                    <el-dropdown-item @click.native.stop="TaskFlowCancelMultiple()">批量取消</el-dropdown-item>
                    <el-dropdown-item @click.native.stop="TaskFlowCloseMultiple()">批量关闭</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-button style="margin-left: 5px;" @click="$refs.taskCreate.Open(projects_id)" type="primary" >新建任务</el-button>
            <files-export-xls-dropdown model="pm_task" :search="post.search" :style="{ marginLeft: '5px', float: 'right' }" />
        </template>

        
        <template slot="search">
            <el-form-item label="任务名称">
                <el-input v-model="post.search.name" @input="$lodash.debounce(Search, 500)" clearable placeholder="任务名称" />
            </el-form-item>
            <el-form-item label="指派给">
                <el-select v-model="post.search.now_assign" @change="Search()" clearable filterable :style="{ width: '100%' }">
                    <el-option v-for="(item, idx) in team" :key="idx" :label="item.user?.name" :value="item.user?.id" />
                </el-select>
            </el-form-item>
            <el-form-item label="里程碑 / 项目阶段">
                <pm-milestone-select @onChange="Search()" v-model="post.search.milestone_id" :projects_id="post.search.project_id" />
            </el-form-item>
            <el-form-item label="任务状态">
                <el-select v-model="post.search.status" @change="Search()" clearable filterable :style="{ width: '100%' }">
                    <el-option :value="0" label="未开始" />
                    <el-option :value="1" label="进行中" />
                    <el-option :value="2" label="已暂停" />
                    <el-option :value="4" label="已关闭" />
                    <el-option :value="5" label="已完成" />
                    <el-option :value="6" label="已取消" />
                </el-select>
            </el-form-item>
            <el-form-item label="是否延期">
                <el-select v-model="post.search.is_overdue" @change="Search()" clearable filterable :style="{ width: '100%' }">
                    <el-option :value="0" label="未延期" />
                    <el-option :value="1" label="已延期" />
                </el-select>
            </el-form-item>
        </template>

        
        <vxe-table ref="xTable" :data="table" height="100%" :sort-config="{ trigger: 'cell', remote: false }" @sort-change="handleSortChange">

            
            <vxe-column type="checkbox" width="45" fixed="left"></vxe-column>

            
            <vxe-column min-width="300" title="任务名称">
                <template #default="{ row }">
                    
                    <el-tag :style="{ marginRight: '5px' }" v-if="row.p == 1" effect="plain" type="danger">P1</el-tag>
                    <el-tag :style="{ marginRight: '5px' }" v-if="row.p == 2" effect="plain" type="warning">P2</el-tag>
                    <el-tag :style="{ marginRight: '5px' }" v-if="row.p == 3" effect="plain" type="primary">P3</el-tag>
                    <el-tag :style="{ marginRight: '5px' }" v-if="row.p == 4" effect="plain" type="success">P4</el-tag>
                    
                    <el-tag :style="{ marginRight: '5px' }" v-if="row.status == 0" effect="dark" type="primary">未开始</el-tag>
                    <el-tag :style="{ marginRight: '5px' }" v-if="row.status == 1" effect="dark" type="primary">进行中</el-tag>
                    <el-tag :style="{ marginRight: '5px' }" v-if="row.status == 2" effect="dark" type="warning">已暂停</el-tag>
                    <el-tag :style="{ marginRight: '5px' }" v-if="row.status == 4" effect="dark" type="info">已关闭</el-tag>
                    <el-tag :style="{ marginRight: '5px' }" v-if="row.status == 5" effect="dark" type="success">已完成</el-tag>
                    <el-tag :style="{ marginRight: '5px' }" v-if="row.status == 6" effect="dark" type="info">已取消</el-tag>
                    
                    <el-tag v-if="row.is_overdue == 1" effect="dark" type="danger">已延期</el-tag>
                    
                    <el-span type="primary" :style="{ color: row.name_color }" @click.native="$refs.taskIndex.Open(row.id)" :title="row.name" />
                </template>
            </vxe-column>

            
            <vxe-column min-width="150" field="name" title="里程碑/项目阶段">
                <template #default="{ row }">
                    {{ row.milestone?.name ?? '-' }}
                </template>
            </vxe-column>

            
            <vxe-column width="120" field="type" title="任务类型" />

            
            <vxe-column width="110" title="指派给">
                <template #default="{ row }">
                    <div style="display: flex; align-items: center; justify-content: flex-start;">
                        <el-avatar style="margin-right: 5px;" :size="26" :src="row.now_assign_user?.avatar"> {{ row.now_assign_user?.name[0] }} </el-avatar>
                        {{  row.now_assign_user?.name }}
                    </div>
                </template>
            </vxe-column>

            
            <vxe-column width="80" field="assign" title="参与人员" :visible="true">
                <template #default="{ row }">
                    <el-tooltip placement="top" :content="row.assign_user_name.toString()">
                        <el-link icon="el-icon-user">{{ row.assign.length }}</el-link>
                    </el-tooltip>
                </template>
            </vxe-column>

            
            <vxe-column min-width="90" field="day_predict" title="任务预期/P"></vxe-column>
            <vxe-column min-width="90" field="day_consume" title="任务消耗/P"></vxe-column>

            
            <vxe-column width="90" field="start_date[0]" title="开始时间" sortable></vxe-column>
            <vxe-column width="90" field="start_date[1]" title="截止时间"></vxe-column>
        </vxe-table>

        
        <template slot="footer">
            <vxe-pager :total="post.page.total" :page-size.sync="post.page.size" :current-page.sync="post.page.current" @page-change="Search()" />
        </template>

        
        <pm-task-create ref="taskCreate" @onSave="Search()" />
        <pm-task-update ref="taskEdit" @onSave="Search()" />
        <pm-task-drawer ref="taskIndex" @onChange="Search()" />
        
        <taskCreateMultiple ref="taskCreateMultiple" @onSave="Search()" />
        <taskEditAssign ref="taskEditAssign" @onSave="Search()"></taskEditAssign>

    </uw-page>
</template>

<script>
import taskCreateMultiple from '@/views/projects/drawerProjectsTaskCreateMultiple'
import taskEditAssign from '@/views/projects/drawerProjectsTaskEditAssign'

export default {
    props: ['projects_id', 'link_query'],

    components: {
        taskCreateMultiple,
        taskEditAssign,
    },

    data () {
        return {
            loading: true,

            table: [],
            team: [],

            post: {
                search: {
                    milestone_id: null,
                    project_id: null,
                    now_assign: null,
                    status: null,
                    is_overdue: null,
                    name: null
                },
                order: {
                    method: 'desc',
                    column: 'id'
                },
                page: {
                    total: 0,
                    size: 20,
                    current: 1,
                },
                append: [ 'milestone', 'now_assign_user', 'type', 'assign_user_object', 'assign_user_name' ],
                hidden: ['describe']
            }
        }
    },

    watch: {
        projects_id: {
            handler (val) {
                if (val) {
                    this.applySearch()
                    this.TeamSearch()
                }
            },
            immediate: true
        },
        link_query: {
            handler() {
                if (this.projects_id) {
                    this.applySearch()
                }
            },
            immediate: true,
            deep: true
        }
    },

    methods: {
        getDefaultSearch() {
            return {
                milestone_id: null,
                project_id: this.projects_id,
                now_assign: null,
                status: null,
                is_overdue: null,
                name: null
            }
        },
        applySearch() {
            this.post.search = {
                ...this.getDefaultSearch(),
                ...this.link_query,
            }
            this.post.page.current = 1
            this.Search()
        },
        Search() {
                        this.$http.post('/9api/pm/task/search', this.post).then(rps => {
                                this.post.page.total = rps.data.total
                this.table = rps.data.body

                                if (this.table.length == 0 && this.post.page.current != 1) {
                    this.post.page.current = 1
                    this.Search()
                }
            })
        },
        TaskDelete(ids) {

            this.$confirm('此操作将永久删除数据，以及关联的数据，包括且不仅限以下内容: 任务工时、任务附件、子任务、统计数据等', '请谨慎操作', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error',
                center: true
            }).then(() => {
                                this.loading = true

                this.$http.post('/9api/projects-task/delete', { ids: ids }).then(rps => {
                    this.Search()
                })
            })
        },

        TaskDeleteMultiple() {
            this.TaskDelete(this.$refs.xTable.getCheckboxRecords().map(item => item.id))
        },
        TaskEditAssign() {
            const ids = this.$refs.xTable.getCheckboxRecords().map(item => item.id)
            this.$refs.taskEditAssign.Open(this.projects_id, ids)
        },
        TeamSearch() {
            this.$http.post('/9api/projects-team/search', { project_id: this.projects_id, append: 'user' }).then(rps => {
                this.team = rps.data
            })
        },
        TaskFlowStartMultiple() {
            this.loading = true
            this.$http.post('/9api/projects-task/flow-start-multiple', { ids: this.$refs.xTable.getCheckboxRecords().map(item => item.id)}).then(rps => {
                this.Search()
            })
        },

        TaskFlowSuspendMultiple() {
            this.loading = true
            this.$http.post('/9api/projects-task/flow-suspend-multiple', { ids: this.$refs.xTable.getCheckboxRecords().map(item => item.id)}).then(rps => {
                this.Search()
            })
        },

        TaskFlowCancelMultiple() {
            this.loading = true
            this.$http.post('/9api/projects-task/flow-cancel-multiple', { ids: this.$refs.xTable.getCheckboxRecords().map(item => item.id)}).then(rps => {
                this.Search()
            })
        },

        TaskFlowCloseMultiple() {
            this.loading = true
            this.$http.post('/9api/projects-task/flow-close-multiple', { ids: this.$refs.xTable.getCheckboxRecords().map(item => item.id)}).then(rps => {
                this.Search()
            })
        },

        // 处理表格排序变化
        handleSortChange({ column, property, order }) {
            if (column && property) {
                // 前端排序
                this.sortTableData(property, order)
            }
        },

        // 前端排序方法
        sortTableData(property, order) {
            const sortedData = [...this.table]
            
            sortedData.sort((a, b) => {
                let aValue = this.getFieldValue(a, property)
                let bValue = this.getFieldValue(b, property)
     
                // 处理日期字段
                if (property === 'start_date[0]') {
                    aValue = new Date(aValue || '1970-01-01')
                    bValue = new Date(bValue || '1970-01-01')
                }
                
                // 处理数字字段
                if (property === 'day_predict') {
                    aValue = parseFloat(aValue) || 0
                    bValue = parseFloat(bValue) || 0
                }
                
                if (order === 'asc') {
                    return aValue > bValue ? 1 : -1
                } else {
                    return aValue < bValue ? 1 : -1
                }
            })
            
            this.table = sortedData
        },

        // 获取字段值的辅助方法
        getFieldValue(row, property) {
            if (property === 'start_date[0]') {
                return row.start_date && row.start_date[0] ? row.start_date[0] : ''
            }
            return row[property]
        }
    }
}
</script>
